<script>
import forminput from "@/router/views/FormComponet/forminput.vue";
import formtextarea from "@/router/views/FormComponet/formtextarea.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrRiskDegerlendirmeKriterTablosu from "@/models/StrRiskDegerlendirmeKriterTablosu";
import moment from "moment";
export default {
  mixins: [Api, Sabit, StrRiskDegerlendirmeKriterTablosu],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
    forminput,
    formtextarea,
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) { 
        this.FormData.KayitTarihi = moment(new Date()).format("YYYY-MM-DD");
        if (this.AddEdit == "Add") {
          this.Post("StrRiskDegerlendirmeKriterTablosu", this.FormData).then((res) => {
            if (res) {
                this.FormData = this.StrRiskDegerlendirmeKriterTablosuData
                this.$emit("TableUpdate");
                this.$bvModal.hide("AddEdit");
            }
          });
        } else {
          this.Update("StrRiskDegerlendirmeKriterTablosu", this.FormData).then((res) => {
            if (res) {
              this.$emit("Update", this.FormData);
              this.FormData = this.StrRiskDegerlendirmeKriterTablosuData
              this.$emit("TableUpdate");
              this.$bvModal.hide("AddEdit");
            }
          });
        }
      }
    },
    Get() {},
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="AddEdit"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('StrRiskDegerlendirmeKriterTablosu.AddEdit.FormTitleEdit')
          : $t('StrRiskDegerlendirmeKriterTablosu.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">  
        <div class="row">
          <div class="col-md-6">
            <forminput
                :FormDataType="FormDataType.Baslangicdegeri"
                :Value="FormData.Baslangicdegeri"
                :v="$v.FormData.Baslangicdegeri"
                @input="FormData.Baslangicdegeri = $event"
            />
          </div>
         <div class="col-md-6">
            <forminput
                :FormDataType="FormDataType.Bitisdegeri"
                :Value="FormData.Bitisdegeri"
                :v="$v.FormData.Bitisdegeri"
                @input="FormData.Bitisdegeri = $event"
                />
            </div>
         </div>
        <forminput
          :FormDataType="FormDataType.Aralik"
          :Value="FormData.Aralik"
          :v="$v.FormData.Aralik"
          @input="FormData.Aralik = $event"
        />
        <formtextarea
          :FormDataType="FormDataType.Olasilik"
          :Value="FormData.Olasilik"
          :v="$v.FormData.Olasilik"
          @input="FormData.Olasilik = $event"
        />
        <formtextarea
          :FormDataType="FormDataType.Etkistrateji"
          :Value="FormData.Etkistrateji"
          :v="$v.FormData.Etkistrateji"
          @input="FormData.Etkistrateji = $event"
        />
        <formtextarea
          :FormDataType="FormDataType.Etkifaaliyetsurec"
          :Value="FormData.Etkifaaliyetsurec"
          :v="$v.FormData.Etkifaaliyetsurec"
          @input="FormData.Etkifaaliyetsurec = $event"
        />
        <formtextarea
          :FormDataType="FormDataType.Etkimali"
          :Value="FormData.Etkimali"
          :v="$v.FormData.Etkimali"
          @input="FormData.Etkimali = $event"
        />
        <formtextarea
          :FormDataType="FormDataType.Etkimevzuatauyum"
          :Value="FormData.Etkimevzuatauyum"
          :v="$v.FormData.Etkimevzuatauyum"
          @input="FormData.Etkimevzuatauyum = $event"
        />
        <button class="btn btn-primary" type="submit">
          {{ $t("StrRiskDegerlendirmeKriterTablosu.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
